<script lang="ts">
	import { webLink } from '@helpers/webLink'
	import { _ } from '@repo/i18n'
	import { Checkbox } from '@repo/ui'

	interface Props {
		checked: boolean
		termsHref?: any
	}

	let { checked = $bindable(), termsHref = webLink('terms-conditions') }: Props = $props()
</script>

<div class="flex flex-wrap items-start justify-start gap-1">
	<Checkbox
		id="acceptTerms"
		name="acceptTerms"
		label={$_('signUpForm.acceptAllStart')}
		required
		small
		bind:checked
	/>
	<span>
		<a class="underline hover:no-underline" href={termsHref} rel="noreferrer" target="_blank"
			>{$_('signUpForm.accept.terms')}</a
		><label class="cursor-pointer" for="acceptTerms">{$_('signUpForm.acceptAllAnd')}</label>
		<a
			class="whitespace-nowrap underline hover:no-underline"
			href={webLink('privacy-policy')}
			rel="noreferrer"
			target="_blank">{$_('signUpForm.accept.privacy')}</a
		>.
	</span>
</div>
